import { BaseAction } from "../../../core/actions/BaseAction";

export class DownloadTicketAction extends BaseAction<void, { passengerDetails: any }> {

    override async run(): Promise<void> {
        try {
            const { passengerDetails } = this.params!;

            const currentFulfillment = passengerDetails?.fulfillment;
            if (!currentFulfillment) return;

            // Look for the PDF_A4 ticket document in the current fulfillment
            const pdfDocument = currentFulfillment.fulfillmentDocuments?.find(
                (doc: any) => doc.medium === "PDF_A4" && doc.type === "TICKET"
            );

            if (pdfDocument?.downloadLink) {
                window.open(pdfDocument.downloadLink, "_blank", "noopener,noreferrer");
            }

        } catch (error) {
            console.error("Error in DownloadTicketAction:", error);
        }
    }
}

// Create a singleton instance
export const downloadTicketAction = new DownloadTicketAction(); 